module.exports = __webpack_public_path__ + "static/media/icon_kei7cda752f107675267149e6b83ef0cdfb.webp";